/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2020-04-28 13:33:20
 *
 *******************************************************/
// @flow

import _ from 'lodash';

/**
 * Check having permission for reading locales
 *
 * @param  {object} accessScopes
 *                         {
 *                            read_products: boolean
                              read_orders: boolean
                              read_themes: boolean
                              read_content: boolean
                              write_themes: boolean
                              read_locales: boolean
                              read_translations: boolean
                              read_locations: boolean
                              read_inventory: boolean
 *                         }
 *
 * @return {boolean}       has permission true | false
 */
export const hasPermissionLocales = accessScopes => {
  return _.get(accessScopes, 'read_locales', false);
};

/**
 * Check having permission for reading content
 *
 * @param  {object} accessScopes
 *
 * @return {boolean}       has permission true | false
 */
export const hasPermissionContent = accessScopes => {
  return _.get(accessScopes, 'read_content', false);
};

/**
 * Check having permission for recommendation
 *
 * @param  {object} accessScopes
 *
 * @return {boolean}       has permission true | false
 */
export const hasPermissionRecommendation = accessScopes => {
  const permissions = ['read_all_orders'];
  return permissions.every((permission: string) => _.get(accessScopes, permission, false));
};

/**
 * Check having permission for bundle discount
 *
 * @param  {object} accessScopes
 *
 * @return {boolean}       has permission true | false
 */
export const hasPermissionBundleDiscount = accessScopes => {
  const permissions = ['read_discounts', 'write_discounts'];
  return permissions.every((permission: string) => _.get(accessScopes, permission, false));
};
